import React from "react";
import "./style.css";
import { Star, Quote} from "lucide-react";

const testimonialsData = [
    {
        name: "Keith M. Mwelaze",
        role: "Best Little Brother",
        quote: "Bonolo is a great sister and a great friend. She is always there for me. She is a great listener and a great advisor. She is always willing to help and support me in any way she can. I am grateful to have her in my life.",
        rating: 5,
    },
    {
        name: "Khensani Ndlhovu",
        role: "Sister-In-Law",
        quote: "She calls me makoti",
        rating: 5,
    },
    {
        name: "Moonface Techs",
        role: "Freelance Web Developer",
        quote: "Helped get my business off the ground. She is a great mentor and a great friend. She is always willing to help and support me in any way she can. I am grateful to have her in my life.",
        rating: 4.5,
    },
]

const Testimonials = () => {
	return (
		<section className="testimonials-section">
			<div className="testimonials-container">
				<div className="testimonials-header">
					<h2>Client Testimonials</h2>
					<div className="hero-underline"></div>
					<p>Read what our valued clients have to say about our legal and tax advisory services.</p>
				</div>

				<div className="testimonials-grid">
					{testimonialsData.map((item, index) => {
						const starCount = Number(item.rating) || 5;

						return (
							<div className="testimonial-card" key={index}>
								<div className="quote-icon">
									<Quote size={32} />
								</div>

								<div className="star-rating">
									{Array.from({ length: starCount }).map((_, i) => (
										<Star key={i} size={18} className="star-icon" fill="var(--accent)" />
									))}
								</div>

								<p className="testimonial-quote">"{item.quote}"</p>

								<div className="client-info">
									<h3 className="client-name">{item.name}</h3>
									<span className="client-role">{item.role}</span>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
};

export default Testimonials;